import React, { Component } from 'react';
import NoDataComponent from '../../common/noDataComponent';
import { withLocalize, Translate } from 'react-localize-redux';

class ResultsList extends Component {

    render() {
        return (
            <>
                <h1><Translate id="Search.Common.Requests" /></h1>
                <br/>
                <NoDataComponent />
            </>
        )
    }
}

export default withLocalize(ResultsList);